/**
 * @generated SignedSource<<6b26f9d1f008d0b98fa8ee6bd3690b37>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            (v3 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
            }
        ],
        "type": "ISchedulableEntity",
        "abstractKey": "__isISchedulableEntity"
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            (v3 /*: any*/)
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v8 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "assignedEntity",
        "plural": false,
        "selections": [
            (v2 /*: any*/),
            (v4 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "asset",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "assetNumber",
                                "storageKey": null
                            },
                            (v3 /*: any*/)
                        ],
                        "storageKey": null
                    }
                ],
                "type": "SchedulableAsset",
                "abstractKey": null
            },
            (v7 /*: any*/)
        ],
        "storageKey": null
    }, v9 = [
        {
            "kind": "Literal",
            "name": "unit",
            "value": "HOUR"
        }
    ], v10 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unit",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
        }
    ], v11 = [
        (v3 /*: any*/),
        (v6 /*: any*/)
    ], v12 = [
        (v3 /*: any*/),
        (v8 /*: any*/),
        {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": (v11 /*: any*/),
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "Schedule",
            "kind": "LinkedField",
            "name": "schedule",
            "plural": false,
            "selections": (v11 /*: any*/),
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "start",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "end",
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "SimultaneousShiftsResultListQuery",
            "selections": [
                {
                    "args": (v1 /*: any*/),
                    "kind": "FragmentSpread",
                    "name": "SimultaneousShiftsResultListFragment"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "SimultaneousShiftsResultListQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "FindSimultaneousSheduleShiftsPayload",
                    "kind": "LinkedField",
                    "name": "findSimultaneousSheduleShifts",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "schedulableEntity",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isSchedulableEntity"
                                },
                                (v4 /*: any*/),
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "User",
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "firstname",
                                                    "storageKey": null
                                                },
                                                (v5 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Avatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        (v3 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "storageId",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "queryTransform",
                                                                    "value": "width=68&height=68&mode=crop&scale=both"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "url",
                                                            "storageKey": "url(queryTransform:\"width=68&height=68&mode=crop&scale=both\")"
                                                        },
                                                        {
                                                            "alias": "imageUrl",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "queryTransform",
                                                                    "value": "width=400&height=400&mode=crop&scale=both"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "url",
                                                            "storageKey": "url(queryTransform:\"width=400&height=400&mode=crop&scale=both\")"
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v3 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "SchedulableUser",
                                    "abstractKey": null
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Asset",
                                            "kind": "LinkedField",
                                            "name": "asset",
                                            "plural": false,
                                            "selections": [
                                                (v6 /*: any*/),
                                                (v5 /*: any*/),
                                                (v3 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "SchedulableAsset",
                                    "abstractKey": null
                                },
                                (v7 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "AssignedEntityWithAssignedSimultaneousDuration",
                            "kind": "LinkedField",
                            "name": "simultaneousAssignedEntities",
                            "plural": true,
                            "selections": [
                                (v8 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v9 /*: any*/),
                                    "concreteType": "TimeSpanUnitValue",
                                    "kind": "LinkedField",
                                    "name": "simultaneousAssignedDurationWithoutUnpaidBreaks",
                                    "plural": false,
                                    "selections": (v10 /*: any*/),
                                    "storageKey": "simultaneousAssignedDurationWithoutUnpaidBreaks(unit:\"HOUR\")"
                                },
                                {
                                    "alias": null,
                                    "args": (v9 /*: any*/),
                                    "concreteType": "TimeSpanUnitValue",
                                    "kind": "LinkedField",
                                    "name": "simultaneousAssignedDurationIncludingBreaks",
                                    "plural": false,
                                    "selections": (v10 /*: any*/),
                                    "storageKey": "simultaneousAssignedDurationIncludingBreaks(unit:\"HOUR\")"
                                },
                                {
                                    "alias": null,
                                    "args": (v9 /*: any*/),
                                    "concreteType": "TimeSpanUnitValue",
                                    "kind": "LinkedField",
                                    "name": "assignedEntityShiftsDurationIncludingBreaks",
                                    "plural": false,
                                    "selections": (v10 /*: any*/),
                                    "storageKey": "assignedEntityShiftsDurationIncludingBreaks(unit:\"HOUR\")"
                                },
                                {
                                    "alias": null,
                                    "args": (v9 /*: any*/),
                                    "concreteType": "TimeSpanUnitValue",
                                    "kind": "LinkedField",
                                    "name": "assignedEntityShiftsDurationWithoutUnpaidBreaks",
                                    "plural": false,
                                    "selections": (v10 /*: any*/),
                                    "storageKey": "assignedEntityShiftsDurationWithoutUnpaidBreaks(unit:\"HOUR\")"
                                },
                                {
                                    "alias": null,
                                    "args": (v9 /*: any*/),
                                    "concreteType": "TimeSpanUnitValue",
                                    "kind": "LinkedField",
                                    "name": "assignedSourceShiftDurationIncludingBreaks",
                                    "plural": false,
                                    "selections": (v10 /*: any*/),
                                    "storageKey": "assignedSourceShiftDurationIncludingBreaks(unit:\"HOUR\")"
                                },
                                {
                                    "alias": null,
                                    "args": (v9 /*: any*/),
                                    "concreteType": "TimeSpanUnitValue",
                                    "kind": "LinkedField",
                                    "name": "assignedSourceShiftDurationWithoutUnpaidBreaks",
                                    "plural": false,
                                    "selections": (v10 /*: any*/),
                                    "storageKey": "assignedSourceShiftDurationWithoutUnpaidBreaks(unit:\"HOUR\")"
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "simultaneousAssignedDaysCount",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "simultaneousAssignedDates",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "assignedSourceDates",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "assignedSourceDays",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "assignedEntityDates",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "assignedEntityDays",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleShiftAndAssignedEntityWithSimultaneousScheduleShifts",
                                    "kind": "LinkedField",
                                    "name": "simultaneousShifts",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleShift",
                                            "kind": "LinkedField",
                                            "name": "simultaneousShifts",
                                            "plural": true,
                                            "selections": (v12 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleShift",
                                            "kind": "LinkedField",
                                            "name": "shift",
                                            "plural": false,
                                            "selections": (v12 /*: any*/),
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "968b1a3d65eaf16d2ccda9f21b94bb0a",
            "id": null,
            "metadata": {},
            "name": "SimultaneousShiftsResultListQuery",
            "operationKind": "query",
            "text": "query SimultaneousShiftsResultListQuery(\n  $model: FindSimultaneousSheduleShiftsInput!\n) {\n  ...SimultaneousShiftsResultListFragment_47b4ea\n}\n\nfragment Asset on Asset {\n  name\n  color\n}\n\nfragment DisplaySchedulableEntity on SchedulableEntity {\n  __isSchedulableEntity: __typename\n  ... on ISchedulableEntity {\n    __isISchedulableEntity: __typename\n    id\n    displayName\n  }\n  ... on SchedulableUser {\n    user {\n      ...User\n      id\n    }\n  }\n  ... on SchedulableAsset {\n    asset {\n      ...Asset\n      id\n    }\n  }\n}\n\nfragment SimultaneousShiftsResultListFragment_47b4ea on Query {\n  findSimultaneousSheduleShifts(model: $model) {\n    schedulableEntity {\n      __typename\n      ...DisplaySchedulableEntity\n      ... on ISchedulableEntity {\n        __isISchedulableEntity: __typename\n        id\n        displayName\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    simultaneousAssignedEntities {\n      assignedEntity {\n        __typename\n        ... on ISchedulableEntity {\n          __isISchedulableEntity: __typename\n          id\n          displayName\n        }\n        ... on SchedulableAsset {\n          asset {\n            assetNumber\n            id\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      simultaneousAssignedDurationWithoutUnpaidBreaks(unit: HOUR) {\n        unit\n        value\n      }\n      simultaneousAssignedDurationIncludingBreaks(unit: HOUR) {\n        unit\n        value\n      }\n      assignedEntityShiftsDurationIncludingBreaks(unit: HOUR) {\n        unit\n        value\n      }\n      assignedEntityShiftsDurationWithoutUnpaidBreaks(unit: HOUR) {\n        unit\n        value\n      }\n      assignedSourceShiftDurationIncludingBreaks(unit: HOUR) {\n        unit\n        value\n      }\n      assignedSourceShiftDurationWithoutUnpaidBreaks(unit: HOUR) {\n        unit\n        value\n      }\n      simultaneousAssignedDaysCount\n      simultaneousAssignedDates\n      assignedSourceDates\n      assignedSourceDays\n      assignedEntityDates\n      assignedEntityDays\n      simultaneousShifts {\n        simultaneousShifts {\n          id\n          assignedEntity {\n            __typename\n            ... on ISchedulableEntity {\n              __isISchedulableEntity: __typename\n              id\n              displayName\n            }\n            ... on SchedulableAsset {\n              asset {\n                assetNumber\n                id\n              }\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          event {\n            id\n            name\n          }\n          schedule {\n            id\n            name\n          }\n          start\n          end\n        }\n        shift {\n          id\n          assignedEntity {\n            __typename\n            ... on ISchedulableEntity {\n              __isISchedulableEntity: __typename\n              id\n              displayName\n            }\n            ... on SchedulableAsset {\n              asset {\n                assetNumber\n                id\n              }\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          event {\n            id\n            name\n          }\n          schedule {\n            id\n            name\n          }\n          start\n          end\n        }\n      }\n    }\n  }\n}\n\nfragment User on User {\n  firstname\n  color\n  avatar {\n    id\n    storageId\n    url(queryTransform: \"width=68&height=68&mode=crop&scale=both\")\n    ...UserImageLightBox\n  }\n}\n\nfragment UserImageLightBox on Avatar {\n  imageUrl: url(queryTransform: \"width=400&height=400&mode=crop&scale=both\")\n}\n"
        }
    };
})();
node.hash = "0ddbb3d2eb709771ad0bc904079c0c5b";
export default node;
